import Avatar from "@components/ui-components/avatar";
import { Badge } from "reactstrap";
import Flex from "@components/ui-components/flex";
// import CustomTooltip from "@components/ui-components/tooltip";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import PropTypes from "prop-types";
import { components } from "react-select";
import { getStatusBadge } from "@helpers/utils";
import { useTranslation } from "react-i18next";

export const MoreSelectedBadge = ({ items, t }) => {
    const style = {
        marginLeft  : "auto",
        background  : "#d4eefa",
        borderRadius: "4px",
        fontSize    : "11px",
        padding     : "3px",
        order       : 99
    };

    const title = items.join(", ");
    const length = items.length;
    const label = `+${length} selected`;

    return (
        <div style={style} title={title}>
            {t(label)}
        </div>
    );
};

MoreSelectedBadge.propTypes = {
    items: PropTypes.array.isRequired,
    t    : PropTypes.any.isRequired   
};

export const MultiValue = ({ index, getValue, ...props }) => {
    const { t } = useTranslation();
    const maxToShow = 4;
    const overflow = getValue()
        .slice(maxToShow)
        .map(x => x.label);
    return index < maxToShow ? (
        <>
            <components.MultiValue {...props} id={props.data.value}>
                <LongNameFormatter
                    content={t(props.data.label)}
                    id={props.data.value}
                    max={20}
                    tag="span"
                    className="text-truncate"/>
            </components.MultiValue>
        </>
    ) : index === maxToShow ? (
        <MoreSelectedBadge items={overflow} t={t} />
    ) : null;
};

MultiValue.propTypes = {
    index   : PropTypes.number,
    getValue: PropTypes.func
};

const { Option } = components;

export const OptionsContainer = (
    props
) => {
    const { data: option } = props;
    // const currentOption = document.querySelector(id ? `#${id.replaceAll(".", "-")}` : ".react-select");
    // const containerWidth = currentOption ? currentOption.clientWidth : 0;
    const { t } = useTranslation();
    return (
        <Option {...props}>
            <Flex align="center" justify="between">
                <Flex align="center">
                    <div className="position-relative options-container">
                        <Avatar
                            img={option.image}
                            icon={option.icon}
                            className="me-25"
                            color={
                                option.icon ? "secondary" : getStatusBadge(option.status)?.color
                            }
                            imgHeight={32}
                            imgWidth={32}
                            content={option.icon ? "" : option.label}
                            rounded
                            initials={!option.image}/>
                    </div>
                    <p className="font-small-4"
                        style={{ fontFamily: option.fontFamily, wordWrap: "break-word" }}>
                        {t(option.label)}
                    </p>
                </Flex>
                <Badge color={getStatusBadge(option.status)?.color} className="badge-sm">
                    {getStatusBadge(option.status)?.title}
                </Badge>
            </Flex>
        </Option>
    );
};

OptionsContainer.propTypes = {
    data: PropTypes.object.isRequired
};